export const styles = theme => ({
    iconButton: {
        
    },
    icon: {
        fontSize: 40,
        float: 'right',
        cursor: 'pointer'
    },
    iconWrap: {
        fontSize: 40,
        float: 'right',
        cursor: 'pointer',
        padding: '4px'
    },
    frameTitle: {
        display: 'flex',
        justifyContent: 'space-between'
    }
})